export class ResponseCartTotalAmountInfoModel {
    oneTimeFee: number;
    monthlyRecurringFee: number;
    currencyCode: string;
}
